import React, { FC, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import { fetchData, fetchFormData, toasterrormsg, toastsuccessmsg } from '../../../reusable';
import { ToastContainer } from 'react-toastify';
import { FileUploader } from "react-drag-drop-files";
import { AddRestaurantHeader } from './AddRestaurantHeader';
import { Tr } from '../../../_metronic/i18n/Tr';

const AddRestaurantMenu: FC = () => {

    const t = Tr()
    const navigate = useNavigate()
    const categoryId = sessionStorage.getItem('categoryId');
    useEffect(() => {
        if (categoryId != '3') {
            navigate('../dashboard/');
        }
    }, [categoryId])
    const location = useLocation();
    const editRestaurantId = (location.state as any)?.restaurantId || '';
    const [restaurantDetails, setRestaurantDetails] = useState([]);
    const primaryLanguage = sessionStorage.getItem("primaryLanguage");

    var vendorId = "";
    const vendorData = sessionStorage.getItem("vendor");
    if (vendorData) {
        var vendor = JSON.parse(vendorData);
        vendorId = vendor.vendorId;

    } else {
        console.log("No vendor data found");
    }
    const [loading, setLoading] = useState(false)
    const [disable, setDisable] = useState(false);
    // set error state
    const [error, setError] = useState([{
        menuNameEN: '',
        menuNameRU: '',
        menuNameUZ: '',
        menuImage: '',
    }]);

    // Validation function
    const validate = () => {
        var isValid = true;
        const newError = [...error] as any;
        // Perform validation based on your rules
        menuFields.forEach((menuItem: any, index: any) => {
            // Ensure newError[index] is initialized as an object
            if (!newError[index]) {
                newError[index] = {};
            }
            // Validate menu names
            if (primaryLanguage == "English") {
                if (!menuItem.en_menuName || !menuItem.en_menuName.trim()) {
                    newError[index].menuNameEN = t('Menu Name Is Required');
                    isValid = false;
                }
            } else if (primaryLanguage == "Russian") {
                if (!menuItem.ru_menuName || !menuItem.ru_menuName.trim()) {
                    newError[index].menuNameRU = t('Menu Name Is Required');
                    isValid = false;
                }
            } else if (primaryLanguage == "Uzbek") {
                if (!menuItem.uz_menuName || !menuItem.uz_menuName.trim()) {
                    newError[index].menuNameUZ = t('Menu Name Is Required');
                    isValid = false;
                }
            }
            // Validate menu image
            if (!menuItem.menuImage) {
                newError[index].menuImage = t('Menu Image Is Required');
                isValid = false;
            }
        });
        setError(newError);
        return isValid;
    };

    // Input change handler
    const handleInputChange = (index: any, fieldName: any, value: any) => {
        const updatedMenuFields = [...menuFields] as any;
        updatedMenuFields[index][fieldName] = value;
        setMenuFields(updatedMenuFields);
    };

    // remove validation function
    const removeError = (index: any, fieldName: any) => {
        let newError = [...error] as any;
        if (!newError[index]) {
            newError[index] = {};
        }
        newError[index][fieldName] = ''; // Clear error
        setError(newError);
    };

    const [menuFields, setMenuFields] = useState([
        { en_menuName: '', ru_menuName: '', uz_menuName: '', menuImage: null, thumbPath: '', imageName: '' }
    ]);

    // Function to handle adding new menu fields
    const addMenuField = () => {
        setMenuFields([...menuFields, { en_menuName: '', ru_menuName: '', uz_menuName: '', menuImage: null, thumbPath: '', imageName: '' }]);
    };

    // Function to handle removing a specific menu field
    const removeMenuField = (index: any) => {
        const updatedMenuFields = [...menuFields];
        updatedMenuFields.splice(index, 1);
        setMenuFields(updatedMenuFields);
    };

    const updateMenuImage = async (index: any, value: any) => {
        const updatedMenuFields = [...menuFields];

        let param = new FormData()

        if (value) {
            param.append('menuImage', value);
        }
        var res = await fetchFormData("public/menuImageUpload", param)
        if (res.status == "200") {
            const data = res.data[0]
            updatedMenuFields[index].imageName = data['imageName'];
            updatedMenuFields[index].thumbPath = data['thumbPath'];
            updatedMenuFields[index].menuImage = value;
        }

        setMenuFields(updatedMenuFields);
    };

    const fileTypes = ["JPEG", "JPG", "PNG"];

    const handleDivClick = (inputId: string) => {
        const inputElement = document.getElementById(inputId);
        if (inputElement) {
            inputElement.click();
        }
    }
    // add business details api call
    const addBusinessDetailsApi = async () => {

        if (validate()) {

            setDisable(true)
            setLoading(true);
            var param: any = {
                restaurantId: String(editRestaurantId),
                menu: menuFields
            }
            var response: any = await fetchData("public/addRestaurantMenuV3", param)
            if (response.status == "200") {
                toastsuccessmsg(t("Restaurant Menu Saved Successfully!"))
                const state = {
                    restaurantId: editRestaurantId
                }
                setTimeout(() => {
                    navigate("../addrestaurantphotos/", { state });
                    setDisable(false)
                    setLoading(false);
                }, 1500);
            }
            else {
                toasterrormsg(response.message)
                setDisable(false)
                setLoading(false);
            }
        }
    }
    //   restaurant list api call
    const restaurantDetailApiCall = async () => {

        var param = {
            'vendorId': vendorId,
            'restaurantId': editRestaurantId
        }
        var res = await fetchData("public/restaurantDetail", param)

        if (res.status == "200") {
            var restaurantData = res.data;
            setRestaurantDetails(restaurantData);
            if (restaurantData[0]["restaurantmenu"].length != 0) {
                setMenuFields(restaurantData[0]["restaurantmenu"])
            }
        }
        else {
            toasterrormsg(res.message)
        }
    }
    useEffect(() => {
        if (editRestaurantId != "") {
            restaurantDetailApiCall();
        }
    }, [])

    return (
        <>
            <ToastContainer />
            <PageTitle breadcrumbs={[]}>{editRestaurantId != "" ? t('Edit Menu') : t('Add Menu')}</PageTitle>
            <AddRestaurantHeader restaurantId={editRestaurantId} />
            <div className="d-flex flex-column flex-column-fluid">
                {/* <!--begin::Content--> */}
                <div id="kt_app_content" className="app-content flex-column-fluid">
                    {/* <!--begin::Form--> */}
                    <div className="form d-flex flex-column flex-lg-row">
                        {/* <!--begin::Main column--> */}
                        <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
                            {/* <!--begin::Tab content--> */}
                            <div className="tab-content">
                                {/* <!--begin::Tab pane--> */}
                                <div className="tab-pane fade show active" id="kt_ecommerce_add_product_general" role="tab-panel">
                                    <div className="d-flex flex-column">
                                        {/* <!--begin::General options--> */}
                                        <div className="card card-flush py-4">
                                            {/* <!--begin::Card header--> */}
                                            <div className="card-header d-flex">
                                                {/* <!--begin::Card title--> */}
                                                <div className="card-title">
                                                    <h2>{t('Menu')}</h2>
                                                </div>
                                                {/* <!--end::Card title--> */}
                                                <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                                                    {
                                                        restaurantDetails.length != 0 ? (
                                                            <>
                                                                {
                                                                    restaurantDetails.map((completedSteps: any, index: any) => {
                                                                        var percentage = 0;
                                                                        if (completedSteps['completedSteps']['basicInfo']) {
                                                                            percentage = 10;
                                                                        }
                                                                        if (completedSteps['completedSteps']['location']) {
                                                                            percentage = 20;
                                                                        }
                                                                        if (completedSteps['completedSteps']['propertyDetail']) {
                                                                            percentage = 40;
                                                                        }
                                                                        if (completedSteps['completedSteps']['menu']) {
                                                                            percentage = 50;
                                                                        }
                                                                        if (completedSteps['completedSteps']['photos']) {
                                                                            percentage = 60;
                                                                        }
                                                                        if (completedSteps['completedSteps']['facilitiesAndServices']) {
                                                                            percentage = 70;
                                                                        }
                                                                        if (completedSteps['completedSteps']['availability']) {
                                                                            percentage = 80;
                                                                        }
                                                                        if (completedSteps['completedSteps']['policies']) {
                                                                            percentage = 90;
                                                                        }
                                                                        if (completedSteps['completedSteps']['financeAndLegal']) {
                                                                            percentage = 100;
                                                                        }
                                                                        return (
                                                                            <React.Fragment key={index}>
                                                                                <div className='d-flex justify-content-between w-100 mt-auto'>
                                                                                    <span className='fw-bold fs-6'>{t('Completion')}</span>
                                                                                    <span className='fw-bolder fs-6'>{percentage}%</span>
                                                                                </div>
                                                                                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                                                                    <div
                                                                                        className='bg-success rounded h-5px'
                                                                                        role='progressbar'
                                                                                        style={{ width: `${percentage}%` }}
                                                                                    ></div>
                                                                                </div>
                                                                            </React.Fragment>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div className='d-flex justify-content-between w-100 mt-auto'>
                                                                    <span className='fw-bold fs-6'>{t('Completion')}</span>
                                                                    <span className='fw-bolder fs-6'>0%</span>
                                                                </div>
                                                                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                                                    <div
                                                                        className='bg-success rounded h-5px'
                                                                        role='progressbar'
                                                                        style={{ width: '0%' }}
                                                                    ></div>
                                                                </div>
                                                            </>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            {/* <!--end::Card header--> */}
                                            {/* <!--begin::Card body--> */}
                                            <div className="card-body pt-10">
                                                {/* <!--begin::Input group--> */}
                                                {menuFields.map((menu, index) => (
                                                    <div className="row" key={index}>
                                                        <div className="col-lg-1"></div>
                                                        <div className="col-lg-8">
                                                            {
                                                                primaryLanguage == "English" && (
                                                                    <>
                                                                        <div className="row">
                                                                            <div className="col-lg-4 my-3">
                                                                                {/* <!--begin::Label--> */}
                                                                                <label className="required fs-4 form-label">{t('Menu Name (English)')}</label>
                                                                                {/* <!--end::Label--> */}
                                                                                {/* <!--begin::Input--> */}
                                                                                <input
                                                                                    type="text"
                                                                                    name={`menuNameEN${index}`}
                                                                                    id={`menuNameEN${index}`}
                                                                                    className="form-control mb-2"
                                                                                    placeholder={t("Menu Name")}
                                                                                    value={menu.en_menuName}
                                                                                    onChange={(e) => { handleInputChange(index, 'en_menuName', e.target.value); removeError(index, 'menuNameEN') }}
                                                                                />
                                                                                {/* <!--end::Input--> */}
                                                                                <div className='text-danger fw-bold'>{error[index]?.menuNameEN}</div>
                                                                            </div>
                                                                            <div className="col-lg-4 my-3">
                                                                                {/* <!--begin::Label--> */}
                                                                                <label className="fs-4 form-label">{t('Menu Name (Russian)')}</label>
                                                                                {/* <!--end::Label--> */}
                                                                                {/* <!--begin::Input--> */}
                                                                                <input
                                                                                    type="text"
                                                                                    name={`menuNameRU${index}`}
                                                                                    id={`menuNameRU${index}`}
                                                                                    className="form-control mb-2"
                                                                                    placeholder={t("Menu Name")}
                                                                                    value={menu.ru_menuName}
                                                                                    onChange={(e) => handleInputChange(index, 'ru_menuName', e.target.value)}
                                                                                />
                                                                                {/* <!--end::Input--> */}
                                                                            </div>
                                                                            <div className="col-lg-4 my-3">
                                                                                {/* <!--begin::Label--> */}
                                                                                <label className="fs-4 form-label">{t('Menu Name (Uzbek)')}</label>
                                                                                {/* <!--end::Label--> */}
                                                                                {/* <!--begin::Input--> */}
                                                                                <input
                                                                                    type="text"
                                                                                    name={`menuNameUZ${index}`}
                                                                                    id={`menuNameUZ${index}`}
                                                                                    className="form-control mb-2"
                                                                                    placeholder={t("Menu Name")}
                                                                                    value={menu.uz_menuName}
                                                                                    onChange={(e) => handleInputChange(index, 'uz_menuName', e.target.value)}
                                                                                />
                                                                                {/* <!--end::Input--> */}
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )
                                                            }
                                                            {
                                                                primaryLanguage == "Russian" && (
                                                                    <>
                                                                        <div className="row">
                                                                            <div className="col-lg-4 my-3">
                                                                                {/* <!--begin::Label--> */}
                                                                                <label className="required fs-4 form-label">{t('Menu Name (Russian)')}</label>
                                                                                {/* <!--end::Label--> */}
                                                                                {/* <!--begin::Input--> */}
                                                                                <input
                                                                                    type="text"
                                                                                    name={`menuNameRU${index}`}
                                                                                    id={`menuNameRU${index}`}
                                                                                    className="form-control mb-2"
                                                                                    placeholder={t("Menu Name")}
                                                                                    value={menu.ru_menuName}
                                                                                    onChange={(e) => { handleInputChange(index, 'ru_menuName', e.target.value); removeError(index, 'menuNameRU') }}
                                                                                />
                                                                                {/* <!--end::Input--> */}
                                                                                <div className='text-danger fw-bold'>{error[index]?.menuNameRU}</div>
                                                                            </div>
                                                                            <div className="col-lg-4 my-3">
                                                                                {/* <!--begin::Label--> */}
                                                                                <label className="fs-4 form-label">{t('Menu Name (English)')}</label>
                                                                                {/* <!--end::Label--> */}
                                                                                {/* <!--begin::Input--> */}
                                                                                <input
                                                                                    type="text"
                                                                                    name={`menuNameEN${index}`}
                                                                                    id={`menuNameEN${index}`}
                                                                                    className="form-control mb-2"
                                                                                    placeholder={t("Menu Name")}
                                                                                    value={menu.en_menuName}
                                                                                    onChange={(e) => handleInputChange(index, 'en_menuName', e.target.value)}
                                                                                />
                                                                                {/* <!--end::Input--> */}
                                                                            </div>
                                                                            <div className="col-lg-4 my-3">
                                                                                {/* <!--begin::Label--> */}
                                                                                <label className="fs-4 form-label">{t('Menu Name (Uzbek)')}</label>
                                                                                {/* <!--end::Label--> */}
                                                                                {/* <!--begin::Input--> */}
                                                                                <input
                                                                                    type="text"
                                                                                    name={`menuNameUZ${index}`}
                                                                                    id={`menuNameUZ${index}`}
                                                                                    className="form-control mb-2"
                                                                                    placeholder={t("Menu Name")}
                                                                                    value={menu.uz_menuName}
                                                                                    onChange={(e) => handleInputChange(index, 'uz_menuName', e.target.value)}
                                                                                />
                                                                                {/* <!--end::Input--> */}
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )
                                                            }
                                                            {
                                                                primaryLanguage == "Uzbek" && (
                                                                    <>
                                                                        <div className="row">
                                                                            <div className="col-lg-4 my-3">
                                                                                {/* <!--begin::Label--> */}
                                                                                <label className="required fs-4 form-label">{t('Menu Name (Uzbek)')}</label>
                                                                                {/* <!--end::Label--> */}
                                                                                {/* <!--begin::Input--> */}
                                                                                <input
                                                                                    type="text"
                                                                                    name={`menuNameUZ${index}`}
                                                                                    id={`menuNameUZ${index}`}
                                                                                    className="form-control mb-2"
                                                                                    placeholder={t("Menu Name")}
                                                                                    value={menu.uz_menuName}
                                                                                    onChange={(e) => { handleInputChange(index, 'uz_menuName', e.target.value); removeError(index, 'menuNameUZ') }}
                                                                                />
                                                                                {/* <!--end::Input--> */}
                                                                                <div className='text-danger fw-bold'>{error[index]?.menuNameUZ}</div>
                                                                            </div>
                                                                            <div className="col-lg-4 my-3">
                                                                                {/* <!--begin::Label--> */}
                                                                                <label className="fs-4 form-label">{t('Menu Name (Russian)')}</label>
                                                                                {/* <!--end::Label--> */}
                                                                                {/* <!--begin::Input--> */}
                                                                                <input
                                                                                    type="text"
                                                                                    name={`menuNameRU${index}`}
                                                                                    id={`menuNameRU${index}`}
                                                                                    className="form-control mb-2"
                                                                                    placeholder={t("Menu Name")}
                                                                                    value={menu.ru_menuName}
                                                                                    onChange={(e) => handleInputChange(index, 'ru_menuName', e.target.value)}
                                                                                />
                                                                                {/* <!--end::Input--> */}
                                                                            </div>
                                                                            <div className="col-lg-4 my-3">
                                                                                {/* <!--begin::Label--> */}
                                                                                <label className="fs-4 form-label">{t('Menu Name (English)')}</label>
                                                                                {/* <!--end::Label--> */}
                                                                                {/* <!--begin::Input--> */}
                                                                                <input
                                                                                    type="text"
                                                                                    name={`menuNameEN${index}`}
                                                                                    id={`menuNameEN${index}`}
                                                                                    className="form-control mb-2"
                                                                                    placeholder={t("Menu Name")}
                                                                                    value={menu.en_menuName}
                                                                                    onChange={(e) => handleInputChange(index, 'en_menuName', e.target.value)}
                                                                                />
                                                                                {/* <!--end::Input--> */}
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )
                                                            }
                                                            <div className='mt-5' id={`menuImage${index}`}>
                                                                <FileUploader
                                                                    multiple={false}
                                                                    handleChange={(file: any) => { updateMenuImage(index, file); removeError(index, 'menuImage') }}
                                                                    name={`menuImage${index}`}
                                                                    types={fileTypes}
                                                                    classes="w-100"
                                                                >
                                                                    <div className="dropzone border-success bg-light-success dz-clickable" id={`menuImage${index}`} onClick={() => { handleDivClick('menuImage') }}>
                                                                        <div className="dz-message needsclick">
                                                                            {/* <!--begin::Icon--> */}
                                                                            <i className="ki-outline ki-file-up text-success fs-3x"></i>
                                                                            {/* <!--end::Icon--> */}
                                                                            {/* <!--begin::Info--> */}
                                                                            <div className="ms-4">
                                                                                <h3 className="fs-5 fw-bold text-gray-900 mb-1">{t('Upload Menu Image')}</h3>
                                                                                <span className="fs-7 fw-semibold text-gray-500">{t('Drag & Drop or choose files from computer')}</span>
                                                                            </div>
                                                                            {/* <!--end::Info--> */}
                                                                        </div>
                                                                    </div>
                                                                </FileUploader>
                                                                {/* <!--begin::Message--> */}
                                                            </div>
                                                            <div className='text-danger fw-bold'>{error[index]?.menuImage}</div>
                                                            <div className="row mt-3">
                                                                {menu.menuImage ? (
                                                                    <div className="col-lg-12 col-3 d-flex flex-column mb-5">
                                                                        <div className='shadow-sm rounded-4' style={{ maxWidth: "fit-content", width: "300px", height: "200px" }}>
                                                                            {(menu.menuImage as any) instanceof File ? (
                                                                                // If menuImage is a file object (during add time)
                                                                                <a href={URL.createObjectURL(menu.menuImage)} target="_blank">
                                                                                    <img className='p-2 rounded-4' src={URL.createObjectURL(menu.menuImage)} width="100%" style={{ width: "300px", height: "200px" }} />
                                                                                </a>
                                                                            ) : (
                                                                                // If menuImage is a URL (during edit time)
                                                                                <a href={menu.menuImage} target="_blank">
                                                                                    <img className='p-2 rounded-4' src={menu.menuImage} width="100%" style={{ width: "300px", height: "200px" }} />
                                                                                </a>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                ) : null}
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-2 d-flex justify-content-lg-start justify-content-end align-items-end my-3">
                                                            {menuFields.length > 1 && index != 0 && (

                                                                <button className="btn btn-danger mb-2 mx-1" onClick={() => removeMenuField(index)}>X</button>
                                                            )}
                                                            <button className="btn btn-success mb-2 mx-1" onClick={addMenuField}>+</button>
                                                        </div>
                                                    </div>
                                                ))}
                                                {/* <!--end::Input group--> */}
                                            </div>
                                            {/* <!--begin::Card body--> */}
                                        </div>
                                        {/* <!--end::Pricing--> */}
                                    </div>
                                </div>
                                {/* <!--end::Tab pane--> */}
                            </div>
                            {/* <!--end::Tab content--> */}
                            <div className="d-flex justify-content-end">
                                {/* <!--begin::Button--> */}
                                <button type="button" disabled={disable} className="btn btn-primary" onClick={addBusinessDetailsApi}>
                                    <span className="indicator-label">{t('Next')}</span>
                                    {loading && (
                                        <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                                    )}
                                </button>
                                {/* <!--end::Button--> */}
                            </div>
                        </div>
                        {/* <!--end::Main column--> */}
                    </div>
                    {/* <!--end::Form--> */}
                </div>
                {/* <!--end::Content--> */}
            </div>
        </>
    )
}

export { AddRestaurantMenu }
